import { User } from "../model/User";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

// update User
export const updateUser = async (user: User): Promise<User> => {
  const response = await axiosInstance.put<{ data: User }>(`/api/user/update/${user.id}`, user);
  return response.data.data;
};
